module.exports = __webpack_public_path__ + "static/img/head3.c348b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head3.png
// module id = 2+AE
// module chunks = 1